/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Application_Models_Sensor_SensorCounterModel } from '../models/BigClock_Application_Models_Sensor_SensorCounterModel';
import type { BigClock_Application_Queries_ReadSensorCoords_ReadSensorCoordsResponse } from '../models/BigClock_Application_Queries_ReadSensorCoords_ReadSensorCoordsResponse';
import type { BigClock_Application_Queries_ReadSensorGpsTime_ReadSensorGpsTimeResponse } from '../models/BigClock_Application_Queries_ReadSensorGpsTime_ReadSensorGpsTimeResponse';
import type { BigClock_Application_Queries_ReadSensorParams_ReadSensorParamsResponse } from '../models/BigClock_Application_Queries_ReadSensorParams_ReadSensorParamsResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SensorBlockService {
    /**
     * @param sensorId
     * @returns BigClock_Application_Queries_ReadSensorGpsTime_ReadSensorGpsTimeResponse Success
     * @throws ApiError
     */
    public static getApiSensorBlockGpsTime(
        sensorId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadSensorGpsTime_ReadSensorGpsTimeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/SensorBlock/{sensorId}/gps/time',
            path: {
                'sensorId': sensorId,
            },
        });
    }
    /**
     * @param sensorId
     * @returns BigClock_Application_Queries_ReadSensorCoords_ReadSensorCoordsResponse Success
     * @throws ApiError
     */
    public static getApiSensorBlockGpsCoords(
        sensorId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadSensorCoords_ReadSensorCoordsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/SensorBlock/{sensorId}/gps/coords',
            path: {
                'sensorId': sensorId,
            },
        });
    }
    /**
     * @param sensorId
     * @returns BigClock_Application_Queries_ReadSensorParams_ReadSensorParamsResponse Success
     * @throws ApiError
     */
    public static getApiSensorBlockParams(
        sensorId: string,
    ): CancelablePromise<BigClock_Application_Queries_ReadSensorParams_ReadSensorParamsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/SensorBlock/{sensorId}/params',
            path: {
                'sensorId': sensorId,
            },
        });
    }
    /**
     * @param sensorId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static postApiSensorBlockCounters(
        sensorId: string,
        requestBody?: BigClock_Application_Models_Sensor_SensorCounterModel,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/SensorBlock/{sensorId}/counters',
            path: {
                'sensorId': sensorId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
